import React from 'react';

import { constants } from '@atlas/core';

import DetailsEventExpandButton from 'components/Pages/Details/DetailsEventExpandButton';
import DetailsEventGroups from 'components/Pages/Details/DetailsEventGroups';

const {
  STATUS: { HIDDEN },
} = constants;

const EventDetailsControls = ({
  activeGroup,
  event,
  expandedMarketTypes,
  handleSetShrinkMarketTypes,
  marketGroups,
  marketTypes,
  setActiveGroup,
}) => {
  if (event.status === HIDDEN) {
    return null;
  }

  return (
    <div className="details-filter-container">
      <DetailsEventGroups
        activeGroup={activeGroup}
        marketGroups={marketGroups}
        setActiveGroup={setActiveGroup}
      />
      <DetailsEventExpandButton
        expandedMarketTypes={expandedMarketTypes}
        marketTypes={marketTypes}
        setExpandedMarketTypes={handleSetShrinkMarketTypes}
      />
    </div>
  );
};

export default EventDetailsControls;
